 <!-- branches: {{branches.length}} <br>
schedulers: {{schedulers.length}} <br>
isReasonRequired: {{ isReasonRequired}} <br>
patientID: {{ patientID}} <br>
practiceID: {{ practiceID}} <br>
branchID: {{ branchID }} <br>
scheduler: {{ scheduler}} <br>
hasTodoTreatments: {{ hasTreatmentsTodo}} 
treatments: {{treatments?.length}}
priceListCodes: {{priceListCodes?.length}}  -->

<div>
    <mat-label>{{ 'FIND-TIME.VISIT-REASON' | translate }} <span *ngIf="isReasonRequired" class="accent-color">*</span></mat-label>
    <button mat-stroked-button type="button" color="primary" class="m-2"
      (click)="onSelectVisitReason('select-from-pricelist')" aria-label="price-list"
      [disabled]="!(practiceID && patientID)">
      {{ 'FIND-TIME.FROM-PRICELIST' | translate }}
    </button>
    <button mat-stroked-button type="button" color="primary"
      (click)="onSelectVisitReason('select-from-card')" aria-label="treatment-card"
      [disabled]="!(practiceID && patientID  && hasTreatmentsTodo)">
      {{ 'FIND-TIME.FROM-TREATMENT-CARD' | translate }}
    </button>
  </div>

  <div class="w-100" fxLayout="column">
    <h4>{{ 'FIND-TIME.TREATMENTS-FOR-APPOINTMENT' | translate }}:
      <button mat-button type="button" *ngIf="treatments?.length || priceListCodes?.length" matSuffix mat-icon-button aria-label="Clear"
        (click)="onClearVisitReason($event)">
        <mat-icon style="font-size:13px;">close</mat-icon>
      </button>
    </h4>



    <div *ngFor="let treatmentItem of treatments">
      <span>{{ getTreatmentSummary(treatmentItem) }}</span>
      <button mat-button matSuffix mat-icon-button aria-label="Clear"
        (click)="onClearTreatment($event, treatmentItem)" class="md-26">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div *ngFor="let pricelistCodeItem of priceListCodes">
      <span>{{ getPriceListSummary(pricelistCodeItem) }}</span>
      <button mat-button matSuffix mat-icon-button aria-label="Clear"
        (click)="onClearPriceListCode($event, pricelistCodeItem)" class="md-26">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
